<template>
    <div>
        <div class="noprint fixed">
            <button class="inp inp2" @click="$emit('close')" style="float: right; padding: 5px 30px ;"><back-icon /> Go Back</button>
        </div>
        <div v-for="(i1, ic) in toReport.items" class="">
            <h1>Item Code: <b>{{ic}}</b></h1>
            <div v-for="(i2, po) in i1" class="pad10">
                <h3>Production Order: <b>{{ po }}</b></h3>
                <div v-for="(i3, dt) in i2"  class="pad10">
                    <h4>date: <b>{{ dt }}</b> &middot; quantity: <b>{{ i3.length }}</b></h4>
                    <div class="pad10">
                        <span v-for="sn in i3"> {{sn}},</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import BackIcon from "vue-material-design-icons/arrow-left"
    import CheckIcon from "vue-material-design-icons/check-all"

    export default {
        name: "reporting",
        props: ['toReport'],
        components: { BackIcon,CheckIcon },
        data() {
            return {
            }
        },
        methods: {
        }
    }
</script>

<style scoped>
    H1, H3, H4 { font-weight: normal; margin: 10px  }
    H1 { border-bottom: solid 1px #ccc; text-align: left; font-size: 1.4em }
    H4 { margin: 5px }
    .pad10  {
        padding: 0 0 0 25px ;}
    SPAN { font-size: 90% }
    .fixed { position: fixed; top: 60px; right: 10px }
</style>